import angular from 'angular';
import { get, has, identity, includes } from 'lodash';

const ALLOWED_STATISTICS = ['median_close', 'median_dom'];
const ALLOWED_FORMATS = {
  'currency_thousands': (value) => "$" + (value && value/1000 + "K")
};

// Used by the native app to render a market chart
module.exports = angular.module('market.routes.market-chart', [
  require('angular-ui-router')
])
.config(function($stateProvider) {
  $stateProvider.state('market-chart', {
    parent: 'root',
    url: `/market-chart/:slug?statistic&format&smoothing`,
    resolve: {
      listing: function(Listing, $stateParams) {
        return Listing.get({ slug: $stateParams.slug }).$promise;
      },
    },
    views: {
      '': {
        template: require('./market-chart.jade')(),
        controller: 'home_market_chart',
        controllerAs: 'home_market_chart',
      },
      'header@': { template: '<div />' },  // disable header
      'footer@': { template: '<div />' },  // disable footer
      'header_xs_down@': { template: '<div />' }, // disable the header on mobile
      'footer_xs_down@': { template: '<div />' }  // disable the footer on mobile
    },
  });
})
.controller('home_market_chart', class {
  constructor($state, $stateParams, listing) {
    if (!includes(ALLOWED_STATISTICS, $stateParams.statistic)) {
      throw 'Invalid statistic provided. Must be one of ' + ALLOWED_STATISTICS.join();
    }
    if ($stateParams.format && !has(ALLOWED_FORMATS, $stateParams.format)) {
      throw 'Invalid format provided. Must not be specified or be one of '
        + Object.keys(ALLOWED_FORMATS).join();
    }

    this.listing = listing;
    this.smoothing = $stateParams.smoothing;
    this.statistic = $stateParams.statistic;
    this.format = $stateParams.format;
  }

  formatY({ value }) {
    return get(
      ALLOWED_FORMATS,
      this.format,
      identity
    )(value);
  }

})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/market-chart.js
 **/